module.exports = __webpack_public_path__ + "static/media/img-app-feature-4@3x.4e3f20a5.png";